import {
  fetchAuthSession,
  getCurrentUser,
  type AuthTokens,
} from "aws-amplify/auth"
import { Cache } from "aws-amplify/utils"
import { isProd } from "./config"

/** @todo: Move to strtmn */

export async function currentSession(): Promise<AuthTokens | undefined> {
  try {
    return (await fetchAuthSession()).tokens ?? undefined
  } catch (err) {
    console.log(err)
    return
  }
}

export const getCurrentUserId = async (): Promise<string> => {
  const currentUser = await getCurrentUser()
  return currentUser.userId
}

/** Determines whether the user is signed in. */
export const isUserSignedIn = async () => {
  try {
    const authUser = await getCurrentUser()
    // console.log("< isUserSignedIn (authUser)")
    return authUser
  } catch (err) {
    // console.log("isUserSignedIn: catch")
    if (!isProd) {
      console.debug("isUserSignedIn: No signed in user:", err)
      console.debug("isUserSignedIn: [DEV] clearing cache")
      // TODO: clear local storage, too (userPref)
      Cache.clear()
    }
    // console.log("< isUserSignedIn (false)")
    return false
  }
}
